$(document).ready(equalHeight);
$(window).on('load', equalHeight);
$(window).on('resize', equalHeight);

function equalHeight() {
    var groups = {};
    $('[data-equal-group]').each(function() {
        var $this = $(this),
            groupId = $this.attr('data-equal-group');
        if (groupId in groups) {
            groups[groupId] = groups[groupId].add($this);
        } else {
            groups[groupId] = $this;
        }
    });
    $.each(groups, function() {
        groupNr = $(this).attr('data-equal-group-nr');
        groupUnset = $(this).attr('data-equal-group-unset');
        groupBreak = $(this).attr('data-equal-group-break');
        groupBreakNr = $(this).attr('data-equal-group-break-nr');

        if(groupNr!=undefined) {
            $(this).css('min-height','').setMinHeight(parseInt(groupNr));
        } else {
            $(this).css('min-height','').setMinHeight(0);
        }
        if(groupBreak!=undefined) {
            if (g_windowWidth <= groupBreak && groupBreakNr!=undefined) {
                $(this).css('min-height','').setMinHeight(parseInt(groupBreakNr));
            }
        }
        if(groupUnset!=undefined) {
            if (g_windowWidth <= groupUnset) {
                $(this).css('min-height','');
            }
        }
    });
}

$.fn.setMinHeight = function(setCount) {
    if (setCount == 0) {
        setCount = this.length;
    }
    for(var i = 0; i < this.length; i+=setCount) {
        var curSet = this.slice(i, i+setCount),
            height = 0;
        curSet.each(function() { height = Math.max(height, $(this).outerHeight()); })
            .css('min-height', height);
    }
    return this;
};
